<template>
	<RefineSearchApplicantCard
		v-if="userIsApplicant"
		:copy="copy"
		:can-retake="canRetakeQuiz"
		:retake-quiz-link="retakeQuizLink"
	/>

	<RefineSearchHiringManagerCard
		v-else
		:copy="copy"
		:can-retake="canRetakeQuiz"
		:retake-quiz-link="retakeQuizLink"
		:display-edit-button="displayEditButton"
		:edit-job-offer-link="editJobOfferLink"
	/>
</template>

<script>
import { mapGetters } from 'vuex'
import {
	RefineSearchApplicantCard,
	RefineSearchHiringManagerCard
} from './_internals'
import {
	personalityRefineSearchCopy,
	personalityRetakeQuizLink
} from '~/utils/personalityRefineSearch'
import { teamAssessmentPath } from '~/utils/assessmentInvitation'

export default {
	name: 'PersonalityRefineSearch',
	components: {
		RefineSearchApplicantCard,
		RefineSearchHiringManagerCard
	},
	props: {
		jobOfferData: {
			type: Object,
			default: null
		},
		applicantData: {
			type: Object,
			default: null
		},
		canRetake: {
			type: Boolean,
			default: false
		},
		hideEditButton: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters('user', ['userIsApplicant']),
		resource() {
			return this.jobOfferData || this.applicantData
		},
		canRetakeQuiz() {
			return Boolean(
				this.canRetake &&
					(this.userIsApplicant ||
						['manager', 'collaborator'].includes(
							this.jobOfferData?.job_responsibility
						))
			)
		},
		retakeQuizLink() {
			if (!this.resource) {
				return null
			}
			if (
				!this.userIsApplicant &&
				this.jobOfferData?.job_responsibility === 'collaborator'
			) {
				return teamAssessmentPath(this.resource.id)
			}

			return personalityRetakeQuizLink(
				this.resource.id,
				this.userIsApplicant
			)
		},
		editJobOfferLink() {
			return this.resource
				? `/job-offer/${this.resource.id}/edit/general`
				: ''
		},
		displayEditButton() {
			return (
				!this.hideEditButton &&
				!this.userIsApplicant &&
				this.jobOfferData?.capabilities?.edit_job === true
			)
		},
		copy() {
			return personalityRefineSearchCopy(this.userIsApplicant)
		}
	}
}
</script>
